module.exports = __webpack_public_path__ + "img/slide-3.0ae6981.webp";